import { Spin } from 'antd'
import CenterContent from './Styled/CenterContent.styled'

const Spinner = () => {
	return (
		<CenterContent>
			<Spin />
		</CenterContent>
	)
}

export default Spinner
